
[...document.querySelectorAll('[data-behaviour="post-list"]')].map(postlist => {

    [...postlist.querySelectorAll('[data-target="item"]')].map(item => {

        item.addEventListener('mouseover', (ev) => {

            const id = item.dataset.id;
            const media = postlist.querySelector('[data-media-id="' + id + '"]');

            if(media) {
                [...postlist.querySelectorAll('[data-target="item"]')].map(allItems => {
                    allItems.setAttribute('data-active', 'false');
                });
                [...postlist.querySelectorAll('[data-target="media"]')].map(allMedia => {
                    allMedia.setAttribute('data-active', 'false');
                });
                item.setAttribute('data-active', 'true');
                media.setAttribute('data-active', 'true');
            }

        });

    });

});